import { memo, useEffect } from 'react'
import { connect } from 'react-redux'
import s from './index.module.less'
import LoadingImage from 'react-loading-image'
import DefaultAvatar from '@/assets/images/avatar_default.png'
import NoLoginAvatar from '@/assets/images/avatar_nologin.png'
import VipSign from '@/assets/images/vip_sign.png'
const Avatar = (props) => {
  const { 
    size = 32,
    userInfo,
    isSkipUserCenter = true
   } = props

  const getUserCenterUrl = () => {
    const urlHost = process.env.REACT_APP_ENV === 'pro' ? 'https://user.3d66.com' : 'https://usertest.3d66.com';
    if(userInfo){
      return urlHost
    }
    const redirectUrl = encodeURIComponent(window.location.href);
    return `${urlHost}/login?login_type=ai_platform&login_url=${redirectUrl}`;
  }

  const AVATAR_STYLE = {
    objectFit: 'contain',
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
  }

  return (
    <div className={s.root} style={{ width: size + 'px', height: size + 'px' }}>
      {isSkipUserCenter ? (
        <a href={getUserCenterUrl()} target='_blank' className='userAvatar' rel="noreferrer">
          <LoadingImage
            src={userInfo ? userInfo?.avatarurl || DefaultAvatar : NoLoginAvatar}
            alt='用户头像'
            style={AVATAR_STYLE}
            loading={() => <img src={DefaultAvatar} style={AVATAR_STYLE} alt=''/>}
            error={() => <img src={DefaultAvatar} style={AVATAR_STYLE} alt=''/>}
          />
          {userInfo && userInfo?.is_vip && <img className='vipSign' src={VipSign} alt='' style={{ width: size + 7 + 'px', height: size + 7  + 'px' }}/>}
        </a>
      ) : (
        <>
          <LoadingImage
            src={userInfo ? userInfo?.avatarurl || DefaultAvatar : NoLoginAvatar}
            alt='用户头像'
            style={AVATAR_STYLE}
            loading={() => <img src={DefaultAvatar} style={AVATAR_STYLE} alt=''/>}
            error={() => <img src={DefaultAvatar} style={AVATAR_STYLE} alt=''/>}
          />
          {userInfo && userInfo?.is_vip && <img className='vipSign' src={VipSign} alt='' style={{ width: size + 7 + 'px', height: size + 7 + 'px' }}/>}
        </>
      )
    
    }
    </div>
  )
}
const mapStateToProps = ({ app }) => {
  return {
    userInfo: app.userInfo,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {}
}
export default memo(connect(mapStateToProps, mapDispatchToProps)(Avatar))
